<template>
  <div>
    <h1>Investor Analysis</h1>
    <div class="pta-content-left">
      <ul>
        <li @click.prevent="showList()" :class="show_list?'active':''">
          <h3>Investor List</h3>
          <p>shows which investors might be interested in your offering</p>
        </li>
        <li @click.prevent="showMap()" :class="show_map?'active':''">
          <h3>Investor World Map</h3>
          <p>shows where potential investors for your offering are located</p>
        </li>
        <li @click.prevent="showChart()" :class="show_chart?'active':''">
          <h3>Investor Pie Chart</h3>
          <p>shows which type of investors might be interested in your offering</p>
        </li>
        <li @click.prevent="showTreeMap()" :class="show_treemap?'active':''">
          <h3>Investor Treemap</h3>
          <p>visualises which type of investors might be interested in your offering</p>
        </li>
        <li @click.prevent="showBarChart()" :class="show_barchart?'active':''">
          <h3>Investor Clustered Bar Chart</h3>
          <p>shows how many investors might be interested in your offering</p>
        </li>
      </ul>
      <a href="/account/calendar" class="pta-button">PROCEED TO BOOK A CALL WITH US</a>
    </div>
    <div class="pta-content-right" :style="show_map?'max-width:1480px;':''">
      <div v-if="show_map">
        <h2 style="margin-bottom:0px;">World Map</h2>
        <div v-if="!is_premium && email_status<1" style="text-align: center;">
          <br /><br />Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.
        </div>
        <div v-else>
          <div class="pta-loading" style="margin-top:30px;" v-if="is_loading">Data is loading ...</div>
          <iframe id="map_url_frame" style="border:0; width:100%; height:710px;background:transparent;" :src="map_url" @load="is_loading=false"></iframe>
        </div>
      </div>
      <div v-if="show_chart">
        <h2 style="margin-bottom:50px;">Pie Chart</h2>
        <div v-if="(!is_premium || !investors.length) && email_status<2" style="text-align: center;">
          <br /><br />Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.
        </div>
        <div v-else>
          <div class="pta-loading" style="margin-top:30px;" v-if="is_loading">Data is loading ...</div>
          <iframe id="piechart_url_frame" style="border:0; width:100%; height:710px;background:transparent;" :src="piechart_url" @load="is_loading=false"></iframe>
        </div>
      </div>
      <div v-if="show_treemap">
        <h2 style="margin-bottom:0px;">Treemap</h2>
        <div v-if="(!is_premium || !investors.length) && email_status<3" style="text-align: center;">
          <br /><br />Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.
        </div>
        <div v-else>
          <div class="pta-loading" style="margin-top:30px;" v-if="is_loading">Data is loading ...</div>
          <iframe id="treemap_url_frame" style="border:0; width:100%; height:710px;background:transparent;" :src="treemap_url" @load="is_loading=false"></iframe>
        </div>
      </div>
      <div v-if="show_barchart">
        <h2 style="margin-bottom:0px;">Bar Chart</h2>
        <div v-if="(!is_premium || !investors.length) && email_status<4" style="text-align: center;">
          <br /><br />Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.
        </div>
        <div v-else>
          <div class="pta-loading" style="margin-top:30px;" v-if="is_loading">Data is loading ...</div>
          <iframe id="barchart_url_frame" style="border:0; width:100%; height:710px;background:transparent;" :src="barchart_url" @load="is_loading=false"></iframe>
        </div>
      </div>
      <div class="pta-investor-selection" v-if="show_list">
        <h2 style="margin-bottom:50px;">Investor List</h2>
        <div v-if="!investors.length" style="text-align: center;">
          Our Artificial Intelligence matching model is currently analysing your submission. Once the process is complete, you will receive an email.
        </div>
        <div v-else>
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th></th>
              <th>Organisation</th>
            <!-- <th>Contact&nbsp;Person</th> -->
              <th>Investor&nbsp;Type</th>
              <th>Preferred Asset Class</th>
              <th>Preferred Geographic Area</th>
            </tr>
            <tr v-if="!investors">
              <td colspan="6" align="center">
                Data is loading ...
              </td>
            </tr>
            <tr v-for="investor in investors" v-if="investors && investor.name">
              <td></td>
              <td valign="top" v-if="!is_premium">******</td>
              <td valign="top" v-if="is_premium">{{ investor.name }}</td>
            <!--  <td valign="top">******</td> -->
              <td valign="top">
                <span v-for="investor_type in investor.investor_types">{{investor_type}}</span>
              </td>
              <td valign="top">
                <span v-for="asset_class in investor.asset_classes">{{asset_class}}</span>
              </td>
              <td valign="top">
                <span v-for="geo in investor.geos">{{geo}}</span>
              </td>
            </tr>
            <!-- <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr>
             <tr>
               <td></td>
               <td>******</td>
               <td>******</td>
               <td><span>Real Estate Investment</span></td>
               <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
               <td><span>Canada</span><span>Germany</span><span>UK</span></td>
             </tr> -->
          </table>
        </div>
        <!-- <p><br />When you become a premium client and more information is gathered about your investment offering, a list that is very similar to this is made and given to you.<br />
           As a premium client, you can look at the full list of investors who are a good fit for you and choose the ones you want to work with.<br />
           Then, we start having formal conversations with the chosen investors with the goal of introducing you to them so that you can give an initial presentation on your investment offer and go through the rest of the steps until they actually invest.</p> -->
      </div>
    </div>
    <div class="pta-clear"></div>
  </div>
</template>
<script>
export default {
  components: {},
  mounted(){

    this.getInvestors();
    this.getQuestionnaire();
  },
  methods: {
    showMap(){
      this.is_loading = true;
      this.show_chart = false;
      this.show_list = false;
      this.show_treemap = false;
      this.show_barchart = false;
      this.show_map = true;
    },
    showList(){
      this.is_loading = true;
      this.show_chart = false;
      this.show_map = false;
      this.show_treemap = false;
      this.show_barchart = false;
      this.show_list = true;
    },
    showChart(){
      this.is_loading = true;
      this.show_list = false;
      this.show_map = false;
      this.show_treemap = false;
      this.show_barchart = false;
      this.show_chart = true;
    },
    showBarChart(){
      this.is_loading = true;
      this.show_list = false;
      this.show_map = false;
      this.show_treemap = false;
      this.show_chart = false;
      this.show_barchart = true;
    },
    showTreeMap(){
      this.is_loading = true;
      this.show_list = false;
      this.show_map = false;
      this.show_chart = false;
      this.show_barchart = false;
      this.show_treemap = true;
    },
    getInvestors(){
      axios.get('/api/investors')
          .then(response => response.data)
          .then(response => {
            this.investors = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    getQuestionnaire(){
      axios.get('/api/user/profile/questionnaire')
          .then(response => response.data)
          .then(response => {
            this.is_loading = true;

            this.is_premium = response.user.profile.is_premium;
            this.email_status = response.user.profile.email_status;
            this.map_url = "https://proptecham.ai/plot/map";
            this.barchart_url = "https://proptecham.ai/plot/bar";
            this.piechart_url = "https://proptecham.ai/plot/pie";
            this.treemap_url = "https://proptecham.ai/plot/tree";

            /*this.map_url = "https://proptecham.ai/plot/"+response.user.profile.hq_country.name+"/"+response.user.profile.asset_country.name+"/"+response.user.profile.fund_category.name+"/"+response.user.profile.fund_type.name.replace("/","%2F")+"/choropleth";
            this.barchart_url = "https://proptecham.ai/plot/"+response.profile.hq_country.name+"/"+response.profile.asset_country.name+"/"+response.profile.fund_category.name+"/"+response.profile.fund_type.name+"/barchart";
            this.piechart_url = "https://proptecham.ai/plot/"+response.profile.hq_country.name+"/"+response.profile.asset_country.name+"/"+response.profile.fund_category.name+"/"+response.profile.fund_type.name+"/piechart";
            this.treemap_url = "https://proptecham.ai/plot/"+response.profile.hq_country.name+"/"+response.profile.asset_country.name+"/"+response.profile.fund_category.name+"/"+response.profile.fund_type.name+"/treemap"; */
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
  },
  data() {
    return {
      show_map: false,
      show_list: true,
      show_chart: false,
      show_treemap: false,
      show_barchart: false,
      is_loading: true,
      investors: '',
      user: '',
      map_url: '',
      treemap_url: '',
      barchart_url: '',
      piechart_url: '',
      is_premium: false,
      email_status: 0
    }
  },
  computed: {
  },
  filters: {
  },
}
</script>